var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('br'),_c('h2',[_vm._v("유튜브 비디오 페이지")]),_c('VideoCategory'),_c('VideoSearchResult')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }